

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// ADDPLANWITHAPPROVAL
// ADDPLANWITHAPPROVAL
const ADDPLANWITHAPPROVAL= createAsyncThunk(
  "addPlanWithApproval/addPlanWithApproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addPlanWithApprovalSlice = createSlice({
  name: "addPlanWithApprovalSlice",
  initialState: {
    addPlanWithApproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddPlanWithApproval: (state) => {
        state.addPlanWithApproval.loading = false
        state.addPlanWithApproval.error = false
        state.addPlanWithApproval.data = []
        state.addPlanWithApproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDPLANWITHAPPROVAL.fulfilled, (state, action) => {
      state.addPlanWithApproval = {
        ...state.addPlanWithApproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDPLANWITHAPPROVAL.pending, (state, action) => {
      state.addPlanWithApproval = {
        ...state.addPlanWithApproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDPLANWITHAPPROVAL.rejected, (state, action) => {
      state.addPlanWithApproval = {
        ...state.addPlanWithApproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addPlanWithApprovalAction = {
    ADDPLANWITHAPPROVAL,
};

export { addPlanWithApprovalAction };
export default addPlanWithApprovalSlice.reducer;
export const {setInitialStateOfaddPlanWithApproval} = addPlanWithApprovalSlice.actions